module.exports = __webpack_public_path__ + "img/barcelo-pool-5.5bae8a6d.jpg";